@if (years && periods) {
  <div class="pa-period-selection-grid">
    <div></div>
    @for (period of periods; track period.periodNr) {
      <div class="pa-period-description">{{ period.periodDescription }}</div>
    }
    @for (year of years; track year.yearNr) {
      <div class="pa-year-description">
        {{ 'schedule.labelAcademicYear' | translate }} {{ year.yearNr }} ({{ year.academicYearDescription }})
      </div>
      @for (period of periods; track period.periodNr) {
        <div
          class="pa-period-cell"
          [id]="'select-period-' + year.yearNr + '-' + period.periodNr"
          [ngClass]="{ 'pa-period-cell-hoverable': selectable && isAvailable(year.yearNr, period.periodNr) }"
          [tabindex]="selectable && isAvailable(year.yearNr, period.periodNr) ? 0 : -1"
          (click)="clickOnPeriod(year, period)"
          (keydown.enter)="clickOnPeriod(year, period)"
        >
          @if (isAvailable(year.yearNr, period.periodNr)) {
            <div class="pa-timeslots">
              @if (showTimeslots && getTimeslots(year.yearNr, period.periodNr).length) {
                @for (timeslot of getTimeslots(year.yearNr, period.periodNr); track timeslot) {
                  <pa-timeslot
                    class="pa-timeslot"
                    [timeslot]="timeslot"
                    [attr.aria-label]="
                      year.yearNr + ' ' + year.academicYearDescription + ' ' + period.periodDescription + ' ' + timeslot
                    "
                  />
                }
              } @else {
                <pa-timeslot class="pa-timeslot pa-timeslot-empty" />
              }
            </div>
          }
        </div>
      }
    }
  </div>
}
